import { Pipe, PipeTransform } from '@angular/core';
import { BatchHistoryStatus } from '@services/cleanfill-api/cleanfill-api.generated';

@Pipe({
  name: 'batchHistoryStatus'
})
export class BatchHistoryStatusPipe implements PipeTransform {
  transform(value: BatchHistoryStatus): string {
    switch (value) {
      case BatchHistoryStatus.Submission:
        return 'Submission';
      case BatchHistoryStatus.FSApproval:
        return 'FS Approval';
      case BatchHistoryStatus.QPApproval:
        return 'QP Approval';
      case BatchHistoryStatus.TransferStart:
        return 'Transfer Start';
      case BatchHistoryStatus.Complete:
        return 'Complete';
    }
  }
}
